import { StyleSheet } from 'aphrodite';

const alertSalmon = '#FFECE7';
const anchovy = '#999BA7';
const amber = '#FFBF00';
const auroMetalSaurus = '#667085';
const backgroundDarkGrey = '#EAECF0';
const backgroundGrey = '#F8F9FB';
const backgroundGrey1 = '#F8F9FA';
const backgroundGrey2 = '#ECF0F4';
const backgroundGrey3 = '#F3F3F4';
const backgroundGrey4 = '#EFEEEE';
const backgroundGrey5 = '#F9FAFB';
const backgroundGrey6 = '#aeb2bd';
const backgroundGrey7 = '#5b6579';
const backgroundLightBlue = '#c9dde1';
const black = '#000000';
const blackberry = '#3B2B4F';
const blue = '#507cf1';
const blue1 = '#1a7bb1';
const blueviolet = '#7969c1';
const bodyText = '#212529';
const brightRed = '#FF0000';
const categoryGrey = '#F3F3F4';
const chartreuse = '#DCFE07';
const coolGrey = '#475467';
const contentVerifiedBlue = '#008AD8';
const danger = '#ed5565';
const darkerSalmon = '#EB4D4D';
const darkBlue = '#1e3a8a';
const darkOrange = '#92400e';
const darkGrey = '#676a6c';
const darkGrey2 = '#D0D5DD';
const darkSlate = '#374151';
const deepGrey = '#444444';
const deeplavender = '#9E8CFF';
const desaturatedBlue = '#1f2937';
const extraLightSalmon = '#FFF6F4';
const filterContainerBoarder = '#e5e5e5';
const fontGrey = '#292929';
const fontGrey2 = '#BFC3C7';
const ghostWhite = '#f8fafc';
const grape = '#9e8cff';
const green = '#1ab394';
const green2 = '#1e7e34';
const grey = '#667085';
const greyBorder = '#E9ECEF';
const greyBackground = '#F9FAFB';
const greyscale = '#474150';
const greyHover = '#EAECF0';
const greyStroke = '#D0D5DD';
const iconGrey = '#a7b1c2';
const iconGrey2 = '#667085';
const kiwiLinkHoverDark = '#6C8A16';
const lightAmber = '#fef3c7';
const lightBrown = '#9d8e43';
const lighterGrey = '#e7eaec';
const lightGreen = '#f2fde1';
const lightGreen2 = '#337e2a';
const lightGreen3 = '#90EE90';
const lightGreen4 = '#3ac28b';
const lightGreyNew = '#F1F2F5';
const lightIndigo = '#e0e7ff';
const lightPurple = '#7969c1';
const lightPurple1 = '#bcbace';
const lightPurple2 = '#f0ecfc';
const lightRed = '#ffcccc';
const lightSalmon = '#ffdfdf';
const lightSlate = '#e2e8f0';
const lightSteel = '#677e88';
const lightYellow = '#fffbda';
const lightTransparentBlue = '#007bff';
const modernSalmon = '#F36E6C';
const modernSalmonBackground = '#FEF3F3';
const orange = '#FFA500';
const orange1 = '#fbb734';
const paleBlue = '#e7f1ff';
const positiveGreen = '#24A477';
const positiveGreenBackground = '#EDF8EF';
const purple = '#3B2B4F';
const purple1 = '#9e88fd';
const red = '#ed6e6d';
const salmon = '#ff5454';
// Shadow colors (rgba values)
const shadowBlue = 'rgba(80, 124, 241, 0.3)';
const shadowBlackberry = 'rgba(59, 43, 79, 0.3)'; // Elevation on blackberry (L4 hierarchy chip)
const shadowGrape = 'rgba(158, 140, 255, 0.19)';
const shadowDark = 'rgba(0, 0, 0, 0.15)';
const shadowLight = 'rgba(0, 0, 0, 0.06)';
const shadowMedium = 'rgba(0, 0, 0, 0.1)';
const shadowOrange = 'rgba(245, 158, 11, 0.3)';
const shadowSoftAmber = 'rgba(245, 158, 11, 0.2)';
const shadowSoftTeal = 'rgba(13, 148, 136, 0.2)';
const shadowSoftBlue = 'rgba(59, 130, 246, 0.2)';
const shadowSoftGreen = 'rgba(16, 185, 129, 0.2)';
const shadowVeryLight = 'rgba(0, 0, 0, 0.05)'; // Very subtle shadow
const shadowSubtle = 'rgba(0, 0, 0, 0.18)';
const shadowElevated = 'rgba(0, 0, 0, 0.22)';
const slateGrey = '#6b7280';
const spinnerOverlayGrey = '#FFFFFFCC';
const squidInk = '#090216';
const steel = '#51636b';
const vividOrange = '#f59e0b';
const yellow = '#ffff00';
const warmBlue = '#6366f1';
const white = '#ffffff';

// Add these colors after line 100 (before the category colors section):

const softAmber = '#f59e0b'; // Softer orange-amber
const softAmberLight = '#fef3c7'; // Very light amber background
const softAmberBackground = 'rgba(245, 166, 35, 0.12)'; // Amber badge background
const softTeal = '#0d9488'; // Gentle teal-green
const softTealLight = '#ccfbf1'; // Light teal background
const softBlue = '#3b82f6'; // Softer blue
const softBlueLight = '#dbeafe'; // Light blue background
const warmGray = '#6b7280'; // Warm gray text
const softGreen = '#10b981'; // Gentle green
const softGreenDark = '#059669'; // Darker green for hover
const softGreenLight = '#d1fae5'; // Light green background
const softPurple = '#8b5cf6'; // Modern purple/violet
const softPurpleDark = '#7c3aed'; // Darker purple/violet for hover
const softPurpleLight = '#ede9fe'; // Light purple background

// Additional soft colors for dashboard widgets
const softBlueDark = '#2563eb'; // Darker blue for gradients
const softAmberDark = '#d97706'; // Darker amber for gradients
const softAmberText = '#856404'; // Bootstrap warning text color
const softTealPrimary = '#14b8a6'; // Primary teal color
const softIndigo = '#6366f1'; // Indigo color
const softIndigoDark = '#4f46e5'; // Darker indigo for gradients

const borderGray = '#e0e0e0'; // Standard border gray
const borderLightGray = '#f0f0f0'; // Very light border gray

// Supplier Brand Table specific colors
const supplierHeaderBg = '#e3f2fd'; // Light blue background for supplier headers
const supplierHeaderText = '#1565c0'; // Dark blue text for supplier headers
const brandHeaderBg = '#f3e5f5'; // Light purple background for brand headers
const brandHeaderText = '#7b1fa2'; // Purple text for brand headers
const idHeaderBg = '#fff3e0'; // Light amber background for ID headers
const idHeaderText = '#ef6c00'; // Orange text for ID headers
const metaHeaderBg = '#e8f5e8'; // Light green background for meta headers
const metaHeaderText = '#2e7d32'; // Green text for meta headers
const supplierCellBg = '#fafffe'; // Very light blue for supplier cells
const brandCellBg = '#fdfaff'; // Very light purple for brand cells
const idCellBg = '#fffef7'; // Very light amber for ID cells
const metaCellBg = '#f9fff9'; // Very light green for meta cells

// Bootstrap and common UI colors
const bootstrapPrimary = '#0d6efd';
const bootstrapDanger = '#dc3545';
const bootstrapSecondary = '#6c757d';
const bootstrapFocus = '#86b7fe';
const lightGrayBorder = '#dee2e6';
const veryLightGray = '#e9ecef';
const mediumGray = '#666666';
const lightGray = '#cccccc';
const lighterGrayBorder = '#dddddd';
const veryLightGrayBorder = '#eeeeee';
const standardGray = '#999999';
const mutedGray = '#888888';
const disabledGray = '#bbbbbb';
const linkHoverBlue = '#0056b3';
const darkGray = '#333333';
const neutralGray = '#e0e0e0';
const inputBorder = '#ced4da';
const lightBackground = '#f9f9f9';
const whiteTransparent15 = 'rgba(255, 255, 255, 0.15)';
const whiteTransparent40 = 'rgba(255, 255, 255, 0.4)';
const whiteTransparent70 = 'rgba(255, 255, 255, 0.7)';

// category colors
const categoryBlack = '#000000';
const categoryBlue = '#278acb';
const categoryGreen = '#2ab34b';
const categoryOrange = '#f06717';
const categoryPink = '#ed0479';

const colorStyles = StyleSheet.create({
  anchovy: { color: anchovy },
  blue: { color: blue },
  coolGrey: { color: coolGrey },
  danger: { color: danger },
  grape: { color: grape },
  green: { color: green },
  lighterGrey: { color: lighterGrey },
  lightPurple: { color: lightPurple },
  salmon: { color: salmon },
  steel: { color: steel },
  auroMetalSaurus: { color: auroMetalSaurus },
});

const backgroundColorStyles = StyleSheet.create({
  alertSalmon: { backgroundColor: alertSalmon },
  backgroundGrey: { backgroundColor: backgroundGrey },
  backgroundGrey2: { backgroundColor: backgroundGrey2 },
  blue: { backgroundColor: blue },
  chartreuse: { backgroundColor: chartreuse },
  fontGrey: { backgroundColor: fontGrey },
  greyStroke: { backgroundColor: greyStroke },
  iconGrey: { backgroundColor: iconGrey },
  lighterGrey: { backgroundColor: lighterGrey },
  lightSalmon: { backgroundColor: lightSalmon },
  salmon: { backgroundColor: salmon },
});

// ─── UPB Viewer Beta palette (mirrors ticket_recou/upb-viewer/project/colors_and_type.css) ───
const upbBetaPrimary = '#7B6AD7';
const upbBetaPrimaryHover = '#4D3CA8';
const upbBetaPrimaryLight = '#EBE9F9';
const upbBetaPrimaryLightRgba = 'rgba(123, 106, 215, 0.12)';
const upbBetaFg1 = '#101828';
const upbBetaFg2 = '#475467';
const upbBetaFg3 = '#667085';
const upbBetaFg4 = '#A2A2A2';
const upbBetaFgInv = '#FFFFFF';
const upbBetaBg1 = '#FFFFFF';
const upbBetaBg2 = '#F9FAFB';
const upbBetaBg3 = '#EAECF0';
const upbBetaBg4 = '#F7F7F7';
const upbBetaBorder1 = '#D0D5DD';
const upbBetaBorder2 = '#EAECF0';
const upbBetaCoolGrey = '#475467';
const upbBetaIconGrey = '#667085';
const upbBetaButtonStrokeGrey = '#A2A2A2';
const upbBetaStrokeGrey = '#D0D5DD';
const upbBetaHoverGrey = '#EAECF0';
const upbBetaWhite = '#FFFFFF';
const upbBetaBlack = '#101828';
const upbBetaSuccess = '#2BC28C';
const upbBetaWarning = '#FFB62F';
const upbBetaError = '#F36E6C';
const upbBetaInfo = '#2196F3';
const upbBetaSuccessBg = '#EDFBF5';
const upbBetaWarningBg = '#FFF8EC';
const upbBetaErrorBg = '#FEF2F2';
const upbBetaSuccessLight = 'rgba(43, 194, 140, 0.12)';
const upbBetaWarningLight = 'rgba(255, 182, 47, 0.12)';
const upbBetaWhiteEmphasis = 'rgba(255, 255, 255, 0.85)';
const upbBetaSkeletonBg = '#F2F4F7';
const upbBetaPrimaryLightRgba14 = 'rgba(123, 106, 215, 0.14)';
const upbBetaWhiteOverlay = 'rgba(255, 255, 255, 0.22)';
const upbBetaErrorText = '#924241'; // dark red text on error_bg (chips/badges)
const upbBetaSuccessText = '#1A7454'; // dark green text on success_bg
const upbBetaErrorBorder = 'rgba(146, 66, 65, 0.5)'; // error_text @ 0.5
const upbBetaSuccessBorder = 'rgba(26, 116, 84, 0.5)'; // success_text @ 0.5
const upbBetaChartBarFill = '#A99DEC'; // lighter purple "units sold" bars
const upbBetaChartPriceHigh = '#15803D'; // highest price paid (green line)
const upbBetaChartPriceLow = '#B42318'; // lowest price paid (red line)
const upbBetaChartPriceMed = '#D97706'; // median price (orange line)
const upbBetaChartCursor = '#98A2B3'; // dashed vertical hover guide

// Marco (UPB Beta copilot) A2UI surface palette
const marcoPieViolet = '#9B6DFF'; // extra pie-slice color (5th)
const marcoPieTeal = '#21B5C4'; // extra pie-slice color (6th)
const marcoPieOrange = '#F2994A'; // extra pie-slice color (7th)
const marcoPieGreen = '#6FCF97'; // extra pie-slice color (8th)
const marcoOnAccent = '#fff'; // text/fill on Marco's accent-colored buttons

export {
  upbBetaPrimary,
  upbBetaPrimaryHover,
  upbBetaPrimaryLight,
  upbBetaPrimaryLightRgba,
  upbBetaFg1,
  upbBetaFg2,
  upbBetaFg3,
  upbBetaFg4,
  upbBetaFgInv,
  upbBetaBg1,
  upbBetaBg2,
  upbBetaBg3,
  upbBetaBg4,
  upbBetaBorder1,
  upbBetaBorder2,
  upbBetaCoolGrey,
  upbBetaIconGrey,
  upbBetaButtonStrokeGrey,
  upbBetaStrokeGrey,
  upbBetaHoverGrey,
  upbBetaWhite,
  upbBetaBlack,
  upbBetaSuccess,
  upbBetaWarning,
  upbBetaError,
  upbBetaInfo,
  upbBetaSuccessBg,
  upbBetaWarningBg,
  upbBetaErrorBg,
  upbBetaSuccessLight,
  upbBetaWarningLight,
  upbBetaWhiteEmphasis,
  upbBetaSkeletonBg,
  upbBetaPrimaryLightRgba14,
  upbBetaWhiteOverlay,
  upbBetaErrorText,
  upbBetaSuccessText,
  upbBetaErrorBorder,
  upbBetaSuccessBorder,
  upbBetaChartBarFill,
  upbBetaChartPriceHigh,
  upbBetaChartPriceLow,
  upbBetaChartPriceMed,
  upbBetaChartCursor,
  marcoPieViolet,
  marcoPieTeal,
  marcoPieOrange,
  marcoPieGreen,
  marcoOnAccent,
  alertSalmon,
  anchovy,
  amber,
  auroMetalSaurus,
  backgroundColorStyles,
  backgroundDarkGrey,
  backgroundGrey,
  backgroundGrey1,
  backgroundGrey2,
  backgroundGrey3,
  backgroundGrey4,
  backgroundGrey5,
  backgroundGrey6,
  backgroundGrey7,
  backgroundLightBlue,
  black,
  blackberry,
  blue,
  blue1,
  blueviolet,
  bodyText,
  bootstrapDanger,
  bootstrapFocus,
  bootstrapPrimary,
  bootstrapSecondary,
  brightRed,
  categoryBlack,
  categoryBlue,
  categoryGreen,
  categoryGrey,
  categoryOrange,
  categoryPink,
  chartreuse,
  colorStyles,
  coolGrey,
  contentVerifiedBlue,
  danger,
  darkGray,
  darkerSalmon,
  darkBlue,
  darkOrange,
  darkGrey,
  darkGrey2,
  darkSlate,
  deepGrey,
  deeplavender,
  desaturatedBlue,
  disabledGray,
  extraLightSalmon,
  filterContainerBoarder,
  fontGrey,
  fontGrey2,
  ghostWhite,
  grape,
  green,
  green2,
  grey,
  greyBackground,
  greyBorder,
  greyscale,
  greyHover,
  greyStroke,
  iconGrey,
  iconGrey2,
  inputBorder,
  kiwiLinkHoverDark,
  lightAmber,
  lightBackground,
  lightBrown,
  lighterGrey,
  lighterGrayBorder,
  lightGray,
  lightGrayBorder,
  linkHoverBlue,
  lightGreen,
  lightGreen2,
  lightGreen3,
  lightGreen4,
  lightGreyNew,
  lightIndigo,
  lightPurple,
  lightPurple1,
  lightPurple2,
  lightRed,
  lightSalmon,
  lightSlate,
  lightSteel,
  lightTransparentBlue,
  lightYellow,
  mediumGray,
  mutedGray,
  modernSalmon,
  modernSalmonBackground,
  neutralGray,
  orange,
  orange1,
  paleBlue,
  positiveGreen,
  positiveGreenBackground,
  warmBlue,
  purple,
  purple1,
  red,
  salmon,
  shadowBlackberry,
  shadowBlue,
  shadowDark,
  shadowGrape,
  shadowLight,
  shadowMedium,
  shadowOrange,
  shadowSoftAmber,
  shadowSoftTeal,
  shadowSoftBlue,
  shadowSoftGreen,
  shadowVeryLight,
  shadowSubtle,
  shadowElevated,
  slateGrey,
  spinnerOverlayGrey,
  squidInk,
  standardGray,
  steel,
  vividOrange,
  veryLightGray,
  veryLightGrayBorder,
  white,
  yellow,
  softAmber,
  softAmberLight,
  softAmberBackground,
  softTeal,
  softTealLight,
  softBlue,
  softBlueLight,
  softGreen,
  softGreenDark,
  softGreenLight,
  softPurple,
  softPurpleDark,
  softPurpleLight,
  softBlueDark,
  softAmberDark,
  softAmberText,
  softTealPrimary,
  softIndigo,
  softIndigoDark,
  borderGray,
  borderLightGray,
  warmGray,
  whiteTransparent15,
  whiteTransparent40,
  whiteTransparent70,
  supplierHeaderBg,
  supplierHeaderText,
  brandHeaderBg,
  brandHeaderText,
  idHeaderBg,
  idHeaderText,
  metaHeaderBg,
  metaHeaderText,
  supplierCellBg,
  brandCellBg,
  idCellBg,
  metaCellBg,
};
